import React from "react";
import Router from "next/router";
import { Modal, message } from "antd";
import Announcement from "@/Announcement/";
import Deposit from "$Deposits/Web/deposit";
import { connect } from "react-redux";
import SelfExclusionModal from "@/SelfExclusionModal";
import AddBankCard from "@/BankAccount/AddBankCard";
import RealNameVerify from "@/Verification/RealNameVerify";
import { getMemberInfoAction } from "$STORE/thunk/memberThunk";
import { getE2BBValue } from "$ACTIONS/helper";
import { APISET, API8SET } from "$ACTIONS/TLCAPI";
import HostConfig from "$ACTIONS/Host.config";
const { LocalHost, HostApi, BFFSCApi } = HostConfig.Config;
import {
    setFEWalletParams,
    setFEWalletParam,
} from "central-payment/platform.pay.config";
import { get, post } from "$ACTIONS/TlcRequest";
import {
    GetDepositMemberBanks,
    GetMemberInfo,
} from "$Deposits/store/actions/DepositAction";
import { promotionActions } from "$STORE/promotionSlice";
import { getSeonSession } from "$ACTIONS/util";

//使用https://febff-api-staging-m2-instance01.fun88.biz
const paymentFebffsc = [
    "/api/Payment/DepositAccountByAmount",
    "/api/Payment/BindReverseDepositAccount",
    '/api/Payment/InsertMemberDepositStepTwoAccessRecord',
    '/api/Payment/GetDepositStepTwoInProgressDetails',
    '/api/Payment/UpdateMemberDepositStepTwoCompleted',
    '/api/Bonus/v2.0',
    '/api/Member',
];
const apiVersion8 = [
    '/api/Bonus/v2.0',
    '/api/Member',
];
class DepositWrap extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            realnameVisible: false, //真實姓名驗證
        };
        const { bonusData, promoTitle } = this.props.selectedBonus || {};
        const isBonusValid = JSON.stringify(bonusData) !== "{}";
        //中心支付配置
        this.privateParams = {
            device: "WEB",
            platformType: "F1",
            languageType: "M2",
            domainName: LocalHost,
            successUrl: LocalHost,
            ActiveMethods: "", //指定存款,默认第一个
            bonusRuleGroupId: isBonusValid ? bonusData?.groupID : undefined,
            bonusId: isBonusValid ? bonusData?.id : undefined,
            bonusName: isBonusValid ? promoTitle : undefined,
            depositingWallet: isBonusValid ? bonusData?.account || "MAIN" : undefined,
            firstName: "",
            e2Backbox: getE2BBValue() || "",
            BackClick: () => {
                this.props.onCancel(); //關閉錢包彈窗
                setTimeout(() => {
                    Router.push("/");
                }, 1500);
            },
            BackMyPromo: () => {
                this.props.onCancel(); //關閉錢包彈窗
                if (Router.router.pathname === "/promotions") {
                    this.props.setBackPromotionPage(true);
                }
                setTimeout(() => {
                    Router.push("/promotions", "/โปรโมชั่น");
                }, 1500);
            },
            ApiDomain: HostApi,
            getSeonSession: getSeonSession,
            ApiGet: (url) => {
                const baseUrl = url.split("?")[0];
                const apis = paymentFebffsc.includes(baseUrl) ? BFFSCApi : HostApi;
                const apiVersion = (apiVersion8.includes(baseUrl) ? API8SET : APISET).slice(1);
                return get(apis + url + apiVersion);
            },
            ApiPost: (url, postdata = "") => {
                const baseUrl = url.split("?")[0];
                const apis = paymentFebffsc.includes(baseUrl) ? BFFSCApi : HostApi;
                const apiVersion = (apiVersion8.includes(baseUrl) ? API8SET : APISET).slice(1);
                return post(
                    apis + url + apiVersion,
                    postdata
                );
            },
            goDeposit: () => {}, //去存款
            goVerifyContact: () => {}, //1st提款 手機、信箱驗證，type: All、Email、Phone
            goFinishKYCInfo: () => {}, //KYC
            goFinishMemberInfo: () => {
                this.goVerifyRealName(); //存款真實姓名驗證
            },

            //添加銀行，添加银行成功需要 call this.props.GetDepositMemberBanks() 或 getList 更新银行卡列表
            goAddBankInfo: (getList, methods = "") => {
                this.addBankCard();
            },

            //聯繫客服
            LivechatClick: () => {
                global.PopUpLiveChat();
            },
            openService: () => {
                global.PopUpLiveChat();
            },

            //歷史紀錄，type = deposit存款记录, withdraw提款记录
            goRecord: () => {
                this.goRecords("deposit");
            },

            toastTip: {
                loading: (str) => {
                    this.props.setLoading(true, str);
                },
                success: (str) => {
                    message.success(str);
                },
                error: (str) => {
                    message.error(str);
                },
                hide: () => {
                    this.props.setLoading(false);
                },
            },
            modalTip: {
                info: (info) => {
                    Modal.info({
                        icon: null,
                        centered: true,
                        title: info.title,
                        okText: info.okBtnTxt,
                        content: info.children,
                        onOk: () => {
                            info.okFunction && info.okFunction();
                        },
                        width: 400,
                        className: `info-general-modal ${info.wrapClassName}`,
                    });
                },
                confirm: (info) => {
                    Modal.confirm({
                        icon: null,
                        centered: true,
                        title: info.title,
                        okText: info.okBtnTxt,
                        cancelText: info.noBtnTxt,
                        content: info.children,
                        onOk: () => {
                            info.okFunction && info.okFunction();
                        },
                        onCancel: () => {
                            info.noFunction && info.noFunction();
                        },
                        width: 400,
                        className: `confirm-general-modal ${info.wrapClassName}`,
                        cancelButtonProps: info.onlyOKBtn
                            ? { style: { display: "none" } }
                            : {},
                    });
                },
            },
            siteId: 37,
            webPiwikEvent: (
                eventCategory,
                action,
                name,
                value = false,
                customVariableArr = []
            ) => {
                Pushgtagdata(
                    eventCategory,
                    action,
                    name,
                    value,
                    customVariableArr
                );
            },
            webPiwikUrl: (
                url,
                trackingTitle = false,
                isTrackPageView = true,
                isOnlyBaseUrl = false
            ) => {
                Pushgtagpiwikurl(
                    url,
                    trackingTitle,
                    isTrackPageView,
                    isOnlyBaseUrl
                );
            },
            appPiwikEvent: () => {},
            appPiwikUrl: () => {},
        };
        setFEWalletParams(this.privateParams);
    }
    async componentDidMount() {
        const {memberInfo} = this.props;
        const depositedMembers = JSON.parse(localStorage.getItem("isDeposited") || "[]");
        const isMemberDeposited = depositedMembers.includes(memberInfo?.userName);
        if (JSON.stringify(memberInfo) === "{}") {
            await this.getmemberInfo();
        }
        const hasDeposited = Boolean(memberInfo?.isDeposited);
        if(hasDeposited && !isMemberDeposited){
            localStorage.setItem("isDeposited", JSON.stringify([...depositedMembers, memberInfo?.userName]));
            global?.fbqTag && fbqTag('firstrecharge');
        }
        global.Pushgtagpiwikurl &&
            global.Pushgtagpiwikurl("deposit", "Deposit");
    }
    componentDidUpdate(prevProps, prevState) {}
    componentWillUnmount() {
        this.props.setSelectedBonus(null);
    }
    // 獲取會員訊息
    getmemberInfo = async () => {
        this.props.setLoading(true);
        await this.props.getMemberInfo(() => {
            this.props.setLoading(false);
        });
    };
    // 真實姓名驗證
    goVerifyRealName = () => {
        Modal.confirm({
            icon: null,
            centered: true,
            title: "ตรวจสอบความปลอดภัย",
            okText: "ยืนยันเลย",
            cancelText: "ยืนยันภายหลัง",
            content:
                "เพื่อรักษาความปลอดภัยให้กับบัญชีกรุณายืนยันชื่อจริงของคุณก่อนดำเนินการฝากเงิน",
            onOk: () => {
                this.setState({ realnameVisible: true });
            },
            onCancel: () => {
                this.props.onCancel("skipRealName"); //關閉錢包
                if(this.props.isGamePage) {
                    if (window.history.length <= 2) {
                        Router.push("/");
                    } else {
                        Router.back();
                    }
                }
            },
            width: 400,
            className: "confirm-general-modal",
        });
    };
    goRecords = (recordType) => {
        let PAGE_TARGET = "transaction-record";
        sessionStorage.setItem("selectTabKey", recordType); //選擇 存款、提款 tab
        if (~window.location.pathname.indexOf("/th/transaction-record")) {
            this.props.onCancel(); //關閉錢包彈窗
            typeof global.changeRecordFilterType === "function" &&
                global.changeRecordFilterType(recordType);
        } else {
            Router.push("/transaction-record");
        }
    };
    addBankCard = () => {
        this.setState({ addBankVisible: true });
    };
    render() {
        const { memberInfo } = this.props;

        setFEWalletParam("firstName", memberInfo?.firstName || "");

        return (
            <React.Fragment>
                {/* 主要內容 */}
                {memberInfo != "" && <Deposit triggerFor="deposit"/>}
                {/* 紧急公告弹窗 */}
                <Announcement optionType="Deposit" />
                {/* 自我限制 */}
                <SelfExclusionModal
                    ModalType={1}
                    OpenModalUrl="Deposit"
                    afterCloseModal={() => {
                        this.props.onCancel();
                        Router.push("/");
                    }}
                />
                {/* 真實姓名驗證 */}
                {this.state.realnameVisible && (
                    <RealNameVerify
                        visible={this.state.realnameVisible}
                        closeModal={() => {
                            this.setState({ realnameVisible: false });
                        }}
                        correctMemberInfo={() => {
                            this.getmemberInfo();
                            this.props.getCentralPaymentMemberInfo();
                        }}
                        isNext={false}
                        closeWallet={() => {
                            this.props.onCancel("skipRealName");
                            if(this.props.isGamePage) {
                                if (window.history.length <= 2) {
                                    Router.push("/");
                                } else {
                                    Router.back();
                                }
                            }
                        }}
                        triggerFrom={"deposit"}
                    />
                )}
                {/* 添加銀行卡 */}
                {this.state.addBankVisible && (
                    <AddBankCard
                        visible={this.state.addBankVisible}
                        closeModal={() => {
                            this.setState({ addBankVisible: false });
                        }}
                        getMemberBanksList={() => {
                            this.props.GetDepositMemberBanks();
                        }}
                        memberInfo={memberInfo}
                        selectedType={"D"}
                        alreadyBindBanks={this.props.DepositMemberBanks}
                    />
                )}
            </React.Fragment>
        );
    }
}

const mapStateToProps = (state) => ({
    MethodsActive: state.MethodsActive,
    DepositMemberBanks: state.DepositMemberBanks,
    selectedBonus: state.promotion.selectedBonus,
    memberInfo: state.userCenter.memberInfo,
});

const mapDispatchToProps = {
    setSelectedBonus: (bonusItem) =>
        promotionActions.setSelectedBonus(bonusItem),
    setBackPromotionPage: (status) =>
        promotionActions.setBackPromotionPage(status),
    getMemberInfo: (callback, refresh) =>
        getMemberInfoAction(callback, refresh),
    GetDepositMemberBanks: (data = "") => GetDepositMemberBanks(data),
    getCentralPaymentMemberInfo: () => GetMemberInfo(),
};

export default connect(mapStateToProps, mapDispatchToProps)(DepositWrap);
